module.exports = __webpack_public_path__ + "static/media/img-no-found.3983e66d.jpg";